import { useNavigate } from 'react-router-dom';
import { TestAccess } from '../hooks/use-test';
import { TEST_BLOCKED_REASON } from '../constants/test-blocked-reason';
import { TEST_PERIOD_NOUN } from '../constants/test-period';

function getBlockedMessage(access: TestAccess): string {
  if (access.reason === TEST_BLOCKED_REASON.MAX_REACHED) {
    const periodNoun = TEST_PERIOD_NOUN[access.period];
    return `You have done ${access.testsCompleted} of ${access.maxTests} tests this ${periodNoun}. Come back next ${periodNoun}.`;
  }

  if (access.reason === TEST_BLOCKED_REASON.DISABLED) {
    return 'Tests are switched off for your organisation.';
  }

  if (access.reason === TEST_BLOCKED_REASON.NO_COURSES) {
    return 'There are no courses available for you yet.';
  }

  return 'Complete more levels to unlock tests.';
}

export function TestBlocked({ access }: { access: TestAccess }) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-screen max-w-lg mx-auto bg-bg-main p-6">
      <h1 className="text-xl font-bold text-title mb-4">Tests</h1>
      <p className="text-subheading">{getBlockedMessage(access)}</p>
      <button
        onClick={() => navigate('/courses')}
        className="mt-4 bg-accent-purple text-white px-4 py-2 rounded-lg"
      >
        Back to Courses
      </button>
    </div>
  );
}
